export default __webpack_public_path__ + "static/media/TL05.d553f2a8.mp3";